import { render, staticRenderFns } from "./CardNavigation.vue?vue&type=template&id=351a716a&scoped=true&"
import script from "./CardNavigation.vue?vue&type=script&lang=js&"
export * from "./CardNavigation.vue?vue&type=script&lang=js&"
import style0 from "./CardNavigation.vue?vue&type=style&index=0&id=351a716a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "351a716a",
  null
  
)

export default component.exports